import React, { Component } from 'react';
import Modal from 'react-modal';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as FormReducer from '../../actions/FormHandler.js';
import AppointmentForm from "./AppointmentForm";
import SuccessPopup from "./SuccessPopup";
import ErrorPopup from "./ErrorPopup";

export class FormContainer extends Component{

    handleCloseModal () {
        this.props.modal.hide();
    }

    render(){
        return (
            <div>
                <Modal isOpen={this.props.isOpen} contentLabel="Modal" className="appointment__modal" style={{overlay: {backgroundColor: 'rgba(71, 76, 76, 0.75)'}}}>
                    <span style={{display: 'flex', justifyContent:'flex-end'}}>
                    <i onClick={this.handleCloseModal.bind(this)} className="fa fa-window-close"></i>
                    </span>
                    <AppointmentForm offset={this.props.offset} gender={this.props.gender} cabinetId={this.props.cabinetId} serviceId={this.props.serviceId} date={this.props.date} time={this.props.time} modal={this.props.modal}
                    />
                </Modal>
                <Modal isOpen={this.props.isAppointed} contentLabel="Modal" className="appointed" style={{overlay: {backgroundColor: 'rgba(71, 76, 76, 0.75)'}}}>
                    <SuccessPopup data={this.props.appointmentDetails} closeHandler={this.props.modal.hideSuccessPopup.bind(this)} />
                </Modal>
                <Modal isOpen={this.props.hasError} contentLabel="Modal" className="not_appointed" style={{overlay: {backgroundColor: 'rgba(71, 76, 76, 0.75)'}}}>
                    <ErrorPopup closeHandler={this.props.modal.hideErrorPopup.bind(this)} message={this.props.appointmentDetails.errorMessage} />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isOpen: state.FormReducer.showModal,
        isAppointed: state.FormReducer.isAppointed,
        hasError: state.FormReducer.hasError,
        appointmentDetails:{
            date: state.FormReducer.date,
            time: state.FormReducer.time,
            ticketNum: state.FormReducer.ticketCount,
            errorMessage: state.FormReducer.message
        },
        date: state.FormReducer.date,
        time: state.FormReducer.time,
        gender: state.AppointmentReducer.gender,
        serviceId: state.AppointmentReducer.id,
        offset: state.AppointmentReducer.offset,
        cabinetId: state.GetCabinet.cabinetId
    }
}

function mapDispatchToProps(dispatch) {
    return {
        modal: bindActionCreators(FormReducer, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);




// WEBPACK FOOTER //
// frontend/src/modules/AppointmentForm/FormContainer.js